const { detect } = require('detect-browser');

const browser = detect();
const allLinks = document.querySelectorAll('a');

let isOldIOS = false;
const versionNumber = parseInt(browser.version, 10);
if (versionNumber <= 9) {
  isOldIOS = true;
}

if (
  browser.name === 'ie' ||
  isOldIOS === true
) {
  for (let i = 0; i < allLinks.length; i++) {
    const link = allLinks[i];
    link.addEventListener('click', e => {
      const url = e.currentTarget.href;
      window.location.href = url;
    });
  }
}



// WEBPACK FOOTER //
// ./assets/js/src/ie-links.js